import React from "react";
import TranslationText from "components/components/Translation/TranslationText";

export function SmartIdWizardErrorHandler({ error, onPrimaryButtonClick, buttonTextKey, children }) {
  if (error) {
    return (
      <div className="smartid-error-message centered-content">
        <label className="error-msg show">
          <TranslationText text={error} />
        </label>
        <div className="smartid-info-btn-row">
          <button
            className="button button-primary"
            type="button"
            onClick={onPrimaryButtonClick}
          >
            <TranslationText text={buttonTextKey} />
          </button>
        </div>
      </div>
    );
  }

  return children;
} 